import React from 'react'
import { Link } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class BannerModuleList extends React.Component {
  state = {
    Products_data: [],
    isEditing: false,
    isloading: false,
  }

  deleteBanner = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/admin/delete-banner/${id}`, {
        headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then(() => {
        Swal.fire({
          title: 'Banner Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.getBannerModule()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  componentDidMount() {
    this.getBannerModule()
  }

  getBannerModule = async () => {
    var that = this
    this.setState({ isloading: true })
    await axios
      .get(Constant.getAPI() + '/admin/list-banners', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }
  onChangeSort = (selectedId) => {
    this.setState({ isEditing: false })

    var data = {
      id: selectedId,
      order: parseInt(this.state.order),
    }

    axios
      .put(Constant.getAPI() + '/admin/update-banner-priority', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getBannerModule()
      })
      .catch(() => {})
  }
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  render() {
    const columns = [
      {
        name: 'banner_img_name',
        label: `Name`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[4]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'banner_img_en',
        label: 'BannerImage: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_thumb_img) => {
            return (
              <div>
                {cruise_thumb_img !== null ? (
                  <div>
                    {cruise_thumb_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                              ? Constant.getImage() + cruise_thumb_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                            ? Constant.getImage() + cruise_thumb_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                        onError={({ currentTarget }) => {
                          currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                        ? Constant.getImage() + cruise_thumb_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={({ currentTarget }) => {
                      currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'banner_img_ar',
        label: 'BannerImage: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_thumb_img) => {
            return (
              <div>
                {cruise_thumb_img !== null ? (
                  <div>
                    {cruise_thumb_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                              ? Constant.getImage() + cruise_thumb_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                            ? Constant.getImage() + cruise_thumb_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                        onError={({ currentTarget }) => {
                          currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                        ? Constant.getImage() + cruise_thumb_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={({ currentTarget }) => {
                      currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/bannerModule-lists/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteBanner.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4> Banner List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/bannerModule-lists/add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    Banner Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Banner List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BannerModuleList
